import React from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Container,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate, useLocation } from "react-router-dom"; // ✅ Import useNavigate and useLocation
import logo from "../../images/homepage/footer/frissly_text.png";

const Logo = styled("img")({
  width: "70px",
  height: "45px",
  objectFit: "contain",
  marginRight: "20px",
});

const Navbar = ({
  aboutUsRef,
  ourProcessRef,
  manufactureRef,
  ingredientsRef,
  contactRef
}) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (ref, sectionId) => {
    if (window.location.pathname !== "/") {
      navigate("/", { state: { section: sectionId } }); // Navigate to home first
    } else {
      setTimeout(() => {
        ref?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100); // Delay for smoother scroll
    }
  };

  return (
    <>
      {isMobile && (
        <Box
          sx={{ background: "var(--Color-90, #0B6E4F)", height: "8px" }}
        ></Box>
      )}

      <Container sx={{ py: "2px" }}>
        <AppBar position="static" color="transparent" elevation={0}>
          {isMobile ? (
            <Box display="flex" alignItems="center" justifyContent="center">
              <Logo src={logo} />
            </Box>
          ) : (
            <Toolbar>
              <Box display="flex" alignItems="center">
                <Logo src={logo} />
              </Box>
              <Box sx={{ flexGrow: 1 }} />
              <Box display="flex" alignItems="center">
                <Button
                  sx={{
                    color: "#014C35",
                    textTransform: "none",
                    fontSize: "18px",
                    fontFamily: "Nunito",
                    fontWeight: "400",
                    lineHeight: "24.55px",
                    padding: "0 30px",
                  }}
                  onClick={() => handleScroll(aboutUsRef, "about-us")}
                >
                  About Us
                </Button>
                <Button
                  sx={{
                    color: "#014C35",
                    textTransform: "none",
                    fontSize: "18px",
                    fontFamily: "Nunito",
                    fontWeight: "400",
                    lineHeight: "24.55px",
                    padding: "0 30px",
                  }}
                  onClick={() => handleScroll(ourProcessRef, "our-process")}
                >
                  Our Process
                </Button>
                <Button
                  sx={{
                    color: "#014C35",
                    textTransform: "none",
                    fontSize: "18px",
                    fontFamily: "Nunito",
                    fontWeight: "400",
                    lineHeight: "24.55px",
                    padding: "0 30px",
                  }}
                  onClick={() => handleScroll(manufactureRef, "manufacture")}
                >
                  Manufacture
                </Button>
                <Button
                  sx={{
                    color: "#014C35",
                    textTransform: "none",
                    fontSize: "18px",
                    fontFamily: "Nunito",
                    fontWeight: "400",
                    lineHeight: "24.55px",
                    padding: "0 30px",
                  }}
                  onClick={() => handleScroll(ingredientsRef, "ingredients")}
                >
                  Ingredients
                </Button>
                <Button
                  sx={{
                    color: "#014C35",
                    textTransform: "none",
                    fontSize: "18px",
                    fontFamily: "Nunito",
                    fontWeight: "400",
                    lineHeight: "24.55px",
                    padding: "0 30px",
                  }}
                  onClick={() => handleScroll(contactRef, "contact-us")}
                >
                  ContactUs
                </Button>
              </Box>
            </Toolbar>
          )}
        </AppBar>
      </Container>
    </>
  );
};

export default Navbar;
